import React from 'react';
import { GlobeIcon, ChevronRightIcon } from 'lucide-react';
interface SectorProps {
  sectors: {
    id: string;
    name: string;
    image: string;
    description: string;
    tourCount: number;
    priceRange: string;
  }[];
  onSectorSelect: (sectorId: string) => void;
}
export const SectorOverview: React.FC<SectorProps> = ({
  sectors,
  onSectorSelect
}) => {
  return <div className="space-y-6" data-id="element-3215">
      <h2 className="text-xl font-semibold text-gray-800" data-id="element-3216">
        Explore Group Tours by Region
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3217">
        {sectors.map(sector => <div key={sector.id} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all cursor-pointer" onClick={() => onSectorSelect(sector.id)} data-id="element-3218">
            <div className="flex h-48" data-id="element-3219">
              <div className="w-1/2" data-id="element-3220">
                <img src={sector.image} alt={sector.name} className="w-full h-full object-cover" data-id="element-3221" />
              </div>
              <div className="w-1/2 p-6 flex flex-col justify-between" data-id="element-3222">
                <div data-id="element-3223">
                  <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-3224">
                    {sector.name}
                  </h3>
                  <p className="text-sm text-gray-600 line-clamp-3" data-id="element-3225">
                    {sector.description}
                  </p>
                </div>
                <div className="mt-4" data-id="element-3226">
                  <div className="flex items-center text-sm text-gray-500 mb-1" data-id="element-3227">
                    <GlobeIcon className="h-4 w-4 mr-2 text-blue-500" data-id="element-3228" />
                    <span data-id="element-3229">{sector.tourCount} tours available</span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-3230">
                    <span className="text-sm font-medium text-blue-600" data-id="element-3231">
                      {sector.priceRange}
                    </span>
                    <div className="flex items-center text-blue-600 text-sm font-medium" data-id="element-3232">
                      View Tours
                      <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-3233" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};